<template>
  <div>
    <ClientOnly>
      <TeacherBreadcrumbs />
    </ClientOnly>
    <NuxtPage v-bind="category && { category: category }" />
  </div>
</template>

<script setup>
const crumbsStore = useBreadcrumbsStore();
const route = useRoute();
const parent = route?.params?.parent;
const { teachersSubject } = useTeachersSubject(parent);

const category = computed(() => teachersSubject?.data?.value);
const selectedChapter = computed(() =>
  category.value?.chapters.find((chapter) => {
    return chapter.highlights.find((highlight) => {
      return highlight.slug === route.query.category;
    });
  }),
);
watch(
  () => category.value,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'parent',
      value: {
        title: `${category.value?.title} ${category.value?.school_class?.title}`,
        slug: `/teacher/${category.value?.slug}`,
        preamble: category.value?.preamble,
      },
    });

    if (selectedChapter.value) {
      crumbsStore.setCrumbs({
        key: 'chapter',
        value: {
          title: selectedChapter.value.number
            ? `Глава ${selectedChapter.value.number}. ${selectedChapter.value.title}`
            : selectedChapter.value.title,
          slug: `/teacher/${category.value?.slug}?category=${selectedChapter.value.slug}`,
        },
      });
    }
  },
  { immediate: true },
);

useHead(
  computed(() => ({
    link: [
      {
        rel: 'canonical',
        href: `https://histrf.ru${route.path}`,
      },
    ],
  })),
);

onBeforeRouteLeave(() => {
  crumbsStore.clearCrumbs();
});
</script>
